import { useCallback } from 'react'
import { safeStringify } from '@stoplight/yaml'
import { saveAs } from 'file-saver'

export function useExportDocumentProps({
  name = 'ninja-api',
  originalDocument,
  bundledDocument,
}: {
  name?: string
  originalDocument?: string
  bundledDocument: unknown
}) {
  const exportDocument = useCallback(
    (document: string) => {
      const blob = new Blob([document], {
        type: `application/yaml`,
      })
      saveAs(blob, `${name}.yaml`)
    },
    [name]
  )

  const exportOriginalDocument = useCallback(() => {
    const stringifiedDocument =
      typeof originalDocument === 'object'
        ? JSON.stringify(originalDocument, null, 2)
        : originalDocument || ''

    exportDocument(stringifiedDocument)
  }, [originalDocument, exportDocument])

  const exportBundledDocument = useCallback(() => {
    const stringifiedDocument = safeStringify(bundledDocument)
    exportDocument(stringifiedDocument)
  }, [bundledDocument, exportDocument])

  return {
    original: {
      onPress: exportOriginalDocument,
    },
    bundled: {
      onPress: exportBundledDocument,
    },
  }
}
